// extracted by mini-css-extract-plugin
export default {"wrapper":"referalModal_wrapper__KTx+f","description":"referalModal_description__Ua2hm"};